/**
 * this closure interfaces with the SubjectFinder
 * API and uses its methods to manipulate the
 * subject finder app
 */
const _subjectFinderIntegration = (function () {
    function SFIntegration({ storage, serviceURL, globals, aiMethods }) {
        const sfScope = this;

        /// ///////////////////////////////////////
        // -- private

        /**
         * get the user by their email address
         *
         * @param {string} email
         * the user's email address to perform the query
         */
        function getUserByEmail(email) {
            const surveyLink = document.querySelector(
                `[data-role="survey-link"]`
            );

            if (origin.match(/localhost/i)) {
                fetch(
                    `${serviceURL}/subject-finder-items?filters=document.email===${email}`
                )
                    .then((res) => res.json())
                    .then((json) => {
                        if (json.length) {
                            window.userUid = json[0].id;

                            surveyLink.href = `${surveyLink.href}?id=${json[0].id}`;
                        }
                    })
                    .catch((err) => {
                        throw new Error(err);
                    });

                return;
            }

            fetch(
                `${origin}/_design/integration-points/subject-finder-subject-list/get-user-by-email?email=${email}`
            )
                .then((res) => res.json())
                .then((json) => {
                    if (json.length) {
                        window.userUid = json[0].id;

                        surveyLink.href = `${surveyLink.href}?id=${json[0].id}`;
                    }
                })
                .catch((err) => {
                    throw new Error(err);
                });
        }

        /**
         * keeps the active progress tab in focus on mobile
         *
         * @return {coid}
         */
        this.activeProgressButtonFocus = function () {
            const { section } = this.activeData;
            const progressBar = document.querySelector(
                `[data-role="navigation"]`
            );
            const barClient = progressBar.getBoundingClientRect();
            const buttonPos = this.navButtons[section].getBoundingClientRect();

            if (buttonPos.right > barClient.width) {
                const xPos = buttonPos.left - barClient.left;

                progressBar.scrollBy({
                    left: xPos,
                    behavior: 'smooth',
                });
            }

            if (buttonPos.left < barClient.left) {
                const xPos = buttonPos.left - barClient.left;

                progressBar.scrollBy({
                    left: xPos,
                    behavior: 'smooth',
                });
            }
        };

        /**
         * there are some nodes that are not within
         * the application's main window and sit
         * outside, these can be referenced to and activated
         * once on the correct section
         *
         * @return {void}
         */
        this.outerSectionNodes = function () {
            const outerSectionNodes = [
                ...document.querySelectorAll(`[data-on-section]`),
            ];
            const { section } = this.activeData;

            outerSectionNodes.forEach((node) => {
                const { onSection } = node.dataset;
                const state = section === onSection ? 'add' : 'remove';

                node.classList[state]('active');
            });
        };

        /**
         * this will go over the controls at the
         * base of the application and set their
         * active state based on the user's position
         * in the process
         */
        this.navControls = function () {
            if (this.active)
                this.getControls()._continue.setAttribute(
                    'form',
                    this.active.id
                );

            // this.setControlState(false, 'back');

            if (!this.isFirst) {
                this.setControlState(true, 'back');
            } else {
                this.setControlState(false, 'back');
            }

            if (!this.isLast) {
                this.setControlState(true, 'skip', 'continue');
                this.setControlState(false, 'restart', 'retake');
            } else {
                this.setControlState(false, 'skip', 'continue');
                this.setControlState(true, 'restart', 'retake');
            }
        };

        /**
         * based on local storage values
         * set the sections or pages that are active
         * when the application loads
         */
        this.pageStates = function () {
            const savedData = storage.get();

            this.each('pages', ({ section, name, page }) => {
                if (
                    !savedData[section] ||
                    !savedData[section].questions ||
                    !savedData[section].questions[name]
                )
                    return;

                const questions = savedData[section].questions[name];

                if (questions) {
                    const questionKeys = Object.keys(questions);

                    questionKeys.forEach((questionKey) => {
                        // hide/show the nsn portion
                        if (questionKey === 'previous-nz-schooling') {
                            const questionInput = document.querySelector(
                                `[name="${questionKey}"][value="${questions[questionKey]}"]`
                            );

                            // set the pages visibility state
                            sfScope.setAcademicPages.bind(this)(
                                questionInput.dataset
                            );
                        }
                    });
                }
            });
        };

        /**
         * hide/show pages based on
         * whether the user has been to
         * an NZ school before
         *
         * @return {void}
         */
        this.setAcademicPages = function (info) {
            const currentData = storage.get();
            const { effect, pages, effectName, showPages, hidePages } = info;

            if (effect === 'hide') {
                window.nsnRetrieved = false;

                this.exclude({
                    pages: pages.split(','),
                });

                if (showPages) {
                    this.include({
                        pages: showPages.split(','),
                    });
                }

                return;
            }

            if (hidePages) {
                this.exclude({
                    pages: hidePages.split(','),
                });

                // if the storage data contains best subjects data
                // enable that page
                if (
                    currentData &&
                    currentData.academic.questions['best-subjects']
                ) {
                    this.include({
                        pages: ['best-subjects'],
                    });
                }
            }

            this.include({
                pages: pages.split(','),
            });
        };

        /**
         * when the application starts up and there
         * is localstorage found, go through all the
         * steps and populate the fields that the user
         * has previously filled in
         */
        this.applyData = function () {
            const emailResults = document.querySelector(
                `[data-role="subscription-card-input"]`
            );
            // const storeEmailAbout = document.querySelector(
            //     `[data-action="store-email"]`
            // );
            const storeEmailResults = document.querySelector(
                `[data-role="subscription-save-email"]`
            );
            const resultsFirstName = document.querySelector(`
                [data-role="subscription-card-username"]
            `);
            const currentStorage = storage.get();

            // storeEmailAbout.checked = currentStorage.emailOptIn;
            storeEmailResults.checked = currentStorage.emailOptIn;
            window.userUid = currentStorage.userUid;

            this.each(
                'pages',
                ({ section, name, page }) => {
                    if (
                        !currentStorage[section] ||
                        !currentStorage[section].questions ||
                        !currentStorage[section].questions[name]
                    )
                        return;

                    const questions = currentStorage[section].questions[name];

                    if (!questions) return;

                    const hasQuestions = Object.keys(questions);

                    hasQuestions.forEach((questionKey) => {
                        const input = page.querySelector(
                            `[name="${questionKey}"]`
                        );

                        if (
                            questionKey === 'users-email' &&
                            questions[questionKey]
                        ) {
                            getUserByEmail.bind(this)(questions[questionKey]);

                            emailResults.value = questions[questionKey];

                            emailResults.disabled = true;
                        }

                        if (
                            questionKey === 'users-name' &&
                            questions[questionKey]
                        ) {
                            resultsFirstName.value = questions[questionKey];

                            resultsFirstName.disabled = true;
                        }

                        if (input) {
                            // go through check boxes
                            if (input.type.match(/checkbox|radio/i)) {
                                // uncheck everything first
                                const allCheckedNodes = [
                                    ...document.querySelectorAll(
                                        `[name="${questionKey}"]`
                                    ),
                                ];

                                allCheckedNodes.forEach((checkedInput) =>
                                    checkedInput.parentNode.classList.remove(
                                        'checked'
                                    )
                                );

                                // check all checked boxes from local storage
                                const checkedNode = document.querySelector(
                                    `[name="${questionKey}"][value="${questions[questionKey]}"]`
                                );

                                if (checkedNode) {
                                    checkedNode.checked = true;

                                    checkedNode.parentElement.classList.add(
                                        'checked'
                                    );
                                } else {
                                    input.checked = true;

                                    input.parentElement.classList.add(
                                        'checked'
                                    );
                                }
                            }

                            // go through all inputs that are not check boxes
                            else if (!input.type.match(/checkbox|radio/i)) {
                                // apply values to nodes that have values in local storage
                                input.value = questions[questionKey];
                            }
                        }
                    });

                    if (globals.subjectInputs)
                        globals.subjectInputs.refreshInputs();
                    if (globals.bestSubjectsInputs)
                        globals.bestSubjectsInputs.refreshInputs();
                },
                true
            );
        };

        /**
         * do page specific things
         * when the page is navigated to
         *
         * @return {void}
         */
        this.apiBestSubjects = function () {
            const academicUserName = document.querySelector(
                `[data-role="academic-users-name"]`
            );
            const currentStorage = storage.get();

            if (currentStorage.about.questions['about-details']) {
                const name =
                    currentStorage.about.questions['about-details'][
                        'users-name'
                    ];

                // academicUserName.textContent = `, ${name}`;
            }
        };

        /**
         * saves the last step the user has visited
         * to local storage
         */
        this.saveCurrentStep = function () {
            const savedData = storage.get();
            const { name, section } = this.activeData;

            savedData.lastPage = name;
            savedData.lastSection = section;

            storage.set(savedData);
        };
    }

    return (props) => {
        return new SFIntegration(props);
    };
})();

export default _subjectFinderIntegration;
